
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {TimelineLite, Timeline} from "gsap";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeScatterSymbol} from "../symbols/SpacierArcadeScatterSymbol";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {SAFreespinEvent} from "../background/SABackground";

export class ScatterRetrigger implements GameRoundPresentation{
    private _hasWin:boolean;
    private _tl:Timeline;
    constructor(){
    }

    public prepare(data:SpacierArcadeParsedGameData):void{
        this._hasWin = data.scatterPositions!.filter((pos) => {return pos > -1}).length > 0;
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null{
        if(!this._hasWin){
            return null;
        }

        let tl:TimelineLite = new TimelineLite();
        const triggerTl:Timeline = this.getReelRetriggerTimeline(data.scatterPositions!, 1);
        tl.add(triggerTl);
        this._tl = tl;
        return this._tl;
    }

    public getReelRetriggerTimeline(scatterPositions:number[], amount:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < scatterPositions.length; i++) {
            if(scatterPositions[i] > -1) {
                let scatterSymbol:SpacierArcadeScatterSymbol = <SpacierArcadeScatterSymbol>Reels.getSymbol(i, scatterPositions[i]);
                timeline.add([
                    () => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_PLUS_SPIN),
                    scatterSymbol.changeState({
                        state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.addFreespin
                    })
                ]);
            }
        }
        return timeline;
    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null{
        if(isActive && this._tl) {
            return this._tl;
        }
        return this.getAnimation(data);
    }

}